// extracted by mini-css-extract-plugin
export default {"Container":"Swiper_Container__Nn9Cx","Dots":"Swiper_Dots__WBkaN","Active":"Swiper_Active__x4XNA"};